import get from 'lodash/get';
import { getIsCartItemsAvailable } from 'bento-ordering/cart/actions/cartAvailable';

/**
 * Action to dispatch edit cart to update fulfillment time and
 * it calls getIsCartItemAvailable if we have items in our cart to
 * determine if cart items are available
 */
const verifyCartItemsStillFulfillable = () => async (dispatch, getState) => {
  const state = getState();
  const { cart, cartWorkingCopy } = state;
  const currentItems = get(cart, 'items', []);

  const requestBody = {
    fulfillment_date: cartWorkingCopy.fulfillment_date,
    fulfillment_time: cartWorkingCopy.fulfillment_time,
    online_ordering_fulfillment_method:
      cartWorkingCopy.online_ordering_fulfillment_method,
    requested_fulfillment_is_asap: cartWorkingCopy.requested_fulfillment_is_asap
  };

  if (currentItems.length > 0) {
    return dispatch(getIsCartItemsAvailable(requestBody));
  }
};

export default verifyCartItemsStillFulfillable;
